import { ICustomerEvetFilterParams } from './types';
import { api } from '../../DefaultService';

export const CUSTOMER_RECOGNITION_EVENT_ENDPOINT =
  'v1/events/recognitions/customers';

export const getAllCustomerEventByLicenseCountAsync = async (
  filter: ICustomerEvetFilterParams,
): Promise<number> => {
  return await api
    .get(`${CUSTOMER_RECOGNITION_EVENT_ENDPOINT}/getAllByLicense/count`, {
      params: { ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
